var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useAuth } from '@agentguru/auth';
import { AppAgencyRoute } from '../components/AppAgencyRoute';
import { BottomNavBarUserProfile } from '../components/BottomNavBarUserProfile';
import { BottomNavBarWhatsNew } from '../components/BottomNavBarWhatsNew';
import { CockpitRoute } from '../components/CockpitRoute';
import { navBarRoutes } from './navBarRoutes';
export function useBottomBarRoutes() {
    var logout = useAuth().logout;
    var routes = useMemo(function () {
        return __spreadArray(__spreadArray([], navBarRoutes, true), [
            {
                key: 1,
                icon: 'ag-profile',
                disabled: false,
                path: '/',
                matches: [],
                isCustomRoute: true,
                subRoutes: [
                    {
                        key: 0,
                        icon: '',
                        disabled: false,
                        path: '/',
                        label: 'BottomNavBarUserProfile',
                        customRender: _jsx(BottomNavBarUserProfile, {}),
                    },
                    {
                        key: 1,
                        icon: '',
                        disabled: false,
                        path: '/',
                        label: 'BottomNavBarWhatsNew',
                        customRender: _jsx(BottomNavBarWhatsNew, {}),
                    },
                    {
                        key: 3,
                        icon: '',
                        disabled: false,
                        path: '/',
                        label: 'AppAgencyRoute',
                        customRender: _jsx(AppAgencyRoute, {}),
                    },
                    {
                        key: 2,
                        icon: '',
                        disabled: false,
                        path: '/',
                        label: 'CockpitRoute',
                        customRender: _jsx(CockpitRoute, {}),
                    },
                    {
                        key: 4,
                        icon: 'ag-logout',
                        disabled: false,
                        path: '/',
                        label: 'Logout',
                        callback: function () { return logout(); },
                    },
                ],
            },
        ], false);
    }, [logout]);
    return routes;
}
